import advanceTransformer from "@/transformers/purchase/advance";
import Vue from "vue";

import moment from "moment";

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 * Fetches all advances
 * @param  status
 * @param  fromDate
 * @param  toDate
 * @param  warehouse
 * @return {Array} Advance's info
 */

function paramsTransformer({ status, fromDate, purchaseOrder, warehouse, provider, jobType }) {
  let finalString = [];

  if (status) {
    finalString.push(`&status=${status}`);
  }
  if (jobType) {
    finalString.push(`&job_type=${jobType}`);
  }
  if (provider) {
    finalString.push(`&provider=${provider}`);
  }
  if (warehouse) {
    finalString.push(`&iwarehouse=${warehouse}`);
  }
  if (fromDate) {
    finalString.push(
      `&start=${fromDate ? moment(fromDate).format("YYYY-MM-DD") : null}`
    );
  }
  if (purchaseOrder) {
    finalString.push(`&oc=${purchaseOrder}`);
  }
  return finalString.join("").replace("&", "?");
}

const fetchAdvances = (options = {}) => {
  return Vue.$http
    .get(`purchase/list/purcharse/orders/${paramsTransformer(options)}`)
    .then((res) => advanceTransformer.fetchCollection(res.data))
    .catch((err) => {
      throw err;
    });
};

export default fetchAdvances;



// WEBPACK FOOTER //
// ./src/services/purchase/advance/fetchAdvances.js